import { checknames, checkpoints } from "../../../../utils/dummy";
import { useEffect, useState } from "react";
import { CgMenuGridR } from "react-icons/cg";
import WallVisitPanel from "./WallVisitPanel";

export default function WallVisitNew({ visits, isLoading }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const getData = () => {
    const groupedData = visits?.reduce((acc: any, item: any) => {
      const stationId = item.station.name;

      if (!acc[stationId]) {
        acc[stationId] = [];
      }
      acc[stationId].order = checkpoints[item?.station?.name];
      acc[stationId].name = checknames[item?.station?.name];
      acc[stationId].push(item);
      return acc;
    }, {});

    const stations = Object.keys(groupedData).map((stationId) => ({
      stationId,
      name: groupedData[stationId].name,
      data: groupedData[stationId],
      order: groupedData[stationId].order,
    }));

    stations.sort((a: any, b: any) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });

    return stations;
  };

  const data = getData();

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextIndex = () => {
    const newIndex = (currentIndex + 1) % data?.length;
    setCurrentIndex(newIndex);
  };

  const goToIndex = (index: any) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextIndex();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [currentIndex]);

  useEffect(() => {
    setVisible(true);
    const interval = setInterval(() => {
      setVisible(false);
    }, 4000);

    return () => {
      clearInterval(interval);
    };
  }, [currentIndex]);

  if (isLoading) {
    return (
      <div className="flex justify-center bg-toyota">
      </div>
    );
  }

  return (
    <div className="flex justify-start items-start w-full">
      <div className="flex flex-col">
        {data?.map((station: any, index: number) => {
          if (station?.stationId !== "Main Gate") {
            return (
              <button
                key={index}
                className={`flex items-center flex-1 w-full  px-6 text-xl py-4 ${
                  index === currentIndex ? "bg-white text-toyota" : "text-white"
                }`}
                onClick={() => goToIndex(index)}
              >
                <div className="">
                  <CgMenuGridR />
                </div>
                <div className="ml-1">{station?.name}</div>
              </button>
            );
          }
        })}
      </div>
      <WallVisitPanel
        isVisible={isVisible}
        setVisible={setVisible}
        station={data[currentIndex]}
      />
    </div>
  );
}
